import React from 'react';
import { FiMessageCircle, FiRadio, FiUsers, FiClock } from 'react-icons/fi';
import { instructorClassWindow, weekFromTitle } from './instructorHome';
import styles from './InstructorHome.module.css';
import StartTeamsMeeting from './StartTeamsMeeting';

const sessionName = (s) => {
  const code = s.course_code || s.elective_code;
  const week = weekFromTitle(s.title);
  const rest = s.title && !/^week\s*\d+\s*$/i.test(s.title) ? s.title.replace(/^week\s*\d+\s*[-–—:·]\s*/i, '') : '';
  const label = week ? `Week ${week}${rest ? `: ${rest}` : ''}` : (rest || s.course_name || s.elective_name || 'Class session');
  return code ? `${code} · ${label}` : label;
};

/**
 * Today's class: the green "Live now" banner while it's on, a quiet card
 * when it's later today. Only the first session is shown; the rest are rare.
 */
export default function LiveBanner({ session, onOpenQna, onAttendance }) {
  if (!session) return null;
  const { start, end, live, ended } = instructorClassWindow(session);
  const open = Number(session.open_question_count) || 0;
  const hasCounts = session.checked_in_count !== undefined && session.enrolled_count !== null && session.enrolled_count !== undefined;

  const kicker = live
    ? `Live now${start ? ` · started ${start.toFormat('h:mm a')}` : ''}`
    : `Today${start ? ` · ${start.toFormat('h:mm a')}${end ? `–${end.toFormat('h:mm a')}` : ''}` : ''}`;

  return (
    <section className={`${styles.live} ${live ? '' : styles.upcoming}`} aria-label={live ? 'Live class' : 'Class later today'}>
      <span className={styles.liveIcon} aria-hidden="true">{live ? <FiRadio size={20} /> : <FiClock size={20} />}</span>
      <div className={styles.liveBody}>
        <span className={styles.liveKicker}>{kicker}</span>
        <span className={styles.liveTitle}>{sessionName(session)}</span>
        {live && (
          <span className={styles.liveMeta}>
            {hasCounts ? `${session.checked_in_count} of ${session.enrolled_count} checked in` : 'Students are checking in'}
            {open > 0 && <> · <b>{open} new {open === 1 ? 'question' : 'questions'}</b></>}
          </span>
        )}
        {!live && <span className={styles.liveMeta}>{ended ? 'Class has ended.' : 'Q&A opens when class starts.'}</span>}
      </div>
      <div className={styles.liveActions}>
        <StartTeamsMeeting url={session.virtual_link} className={live ? styles.liveBtn : ''} />
        {(live || ended) && <button type="button" className={`${styles.btn} ${live ? styles.liveBtn : ''}`} onClick={() => onOpenQna(session)}>
          <FiMessageCircle size={15} aria-hidden="true" />
          {ended ? 'View Q&A' : open > 0 ? `Open Q&A · ${open}` : 'Open Q&A'}
        </button>}
        <button type="button" className={`${styles.btn} ${live ? styles.liveBtnGhost : ''}`} onClick={onAttendance}>
          <FiUsers size={15} aria-hidden="true" />
          Attendance
        </button>
      </div>
    </section>
  );
}
